import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MaterialModule } from '@app/plugins/material/material.module'
import { SharedModule } from '@app/shared/shared.module'
import { NgxMaskDirective } from 'ngx-mask'
import { ScopeUiCounterComponent } from '../ui-components/scope-ui-counter/scope-ui-counter.component'
import { ScopeUiDatepickerComponent } from '../ui-components/scope-ui-datepicker/scope-ui-datepicker.component'
import { ScopeUiDropdownComponent } from '../ui-components/scope-ui-dropdown/scope-ui-dropdown.component'
import { ScopeUiInputComponent } from '../ui-components/scope-ui-input/scope-ui-input.component'
import { ScopeUiTableComponent } from '../ui-components/scope-ui-table/scope-ui-table.component'
import { ComponentsRowHeaderComponent } from './components-row-header/components-row-header.component'
import { ComponentsRowComponent } from './components-row/components-row.component'
import { ComponentsComponent } from './components/components.component'
import { DeliverableSectionsHeaderComponent } from './deliverable-sections-header/deliverable-sections-header.component'
import { DeliverableSectionsRowComponent } from './deliverable-sections-row/deliverable-sections-row.component'
import { DeliverableSectionsComponent } from './deliverable-sections/deliverable-sections.component'
import { DeliverablesRowHeaderComponent } from './deliverables-row-header/deliverables-row-header.component'
import { DeliverablesRowComponent } from './deliverables-row/deliverables-row.component'
import { DeliverablesComponent } from './deliverables/deliverables.component'
import { DepartmentsHeaderComponent } from './departments-header/departments-header.component'
import { DepartmentsRowComponent } from './departments-row/departments-row.component'
import { DepartmentsComponent } from './departments/departments.component'
import { FeesComponent } from './fees/fees.component'
import { RolesHeaderComponent } from './roles-header/roles-header.component'
import { RolesRowComponent } from './roles-row/roles-row.component'
import { RolesComponent } from './roles/roles.component'
import { ThirdPartyCostsComponent } from './third-party-costs/third-party-costs.component'
import { ScopeFieldDifferenceComponent } from './scope-field-difference/scope-field-difference.component'

const components = [
  DeliverablesComponent,
  DeliverablesRowHeaderComponent,
  DeliverablesRowComponent,
  ComponentsComponent,
  ComponentsRowHeaderComponent,
  ComponentsRowComponent,
  DepartmentsComponent,
  DepartmentsHeaderComponent,
  DepartmentsRowComponent,
  RolesComponent,
  RolesHeaderComponent,
  RolesRowComponent,
  DeliverableSectionsComponent,
  DeliverableSectionsHeaderComponent,
  DeliverableSectionsRowComponent,
  ThirdPartyCostsComponent,
  FeesComponent,
  ScopeFieldDifferenceComponent,
]

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    MatIconModule,
    NgxMaskDirective,
    ScopeUiTableComponent,
    ScopeUiCounterComponent,
    ScopeUiInputComponent,
    ScopeUiDatepickerComponent,
    ScopeUiDropdownComponent,
  ],
  declarations: components,
  exports: components,
  providers: [],
})
export class ScopeElementsModule {}
